import { BoxSelection as TPABoxSelection } from '@wix/wix-ui-tpa/cssVars';
import { Checkbox } from '@wix/wix-ui-tpa/cssVars';
import classNames from 'classnames';
import React from 'react';
import { useFocusFieldEvent } from '../../contexts/events-context';
import { classes } from './box-selection-item-wut.st.css';
export const BoxSelectionItem = (props)=>{
    const optionRef = /*#__PURE__*/ React.createRef();
    const { content, className, hasError, inputId, ...optionProps } = props;
    const optionClassName = classNames(className, classes.option, classes.theme, {
        [classes.hover]: props.forcedHover,
        [classes.error]: hasError
    });
    useFocusFieldEvent(()=>{
        optionRef.current?.focus({
            preventScroll: true
        });
    }, inputId);
    return /*#__PURE__*/ React.createElement(TPABoxSelection.Option, {
        ...optionProps,
        ref: optionRef,
        className: optionClassName
    }, content);
};
BoxSelectionItem.includeCheckboxInBundle = Checkbox;

//# sourceMappingURL=box-selection-item.js.map